import {MediaCardType} from '@wandb/weave/common/types/media';
import {GroupedList} from '@wandb/weave/common/util/data';

import {keyDisplayName} from '../../../util/runs';
import {TileMedia, TileMediaSpec} from '../../MediaCard';
import {Tile} from './types';

export function getTileMediaLabels({
  mediaSliderKey,
  mediaSliderKeyValue,
  step,
  index,
}: Pick<
  TileMedia,
  'mediaSliderKey' | 'mediaSliderKeyValue' | 'step' | 'index'
>): {
  stepLabel: string;
  sliderLabel?: string;
  indexLabel?: string;
} {
  const sliderKey = mediaSliderKey ?? '_step';
  const label = keyDisplayName({
    section: 'summary',
    name: sliderKey,
  });
  const sliderLabel =
    mediaSliderKey !== '_step' ? `${label}: ${mediaSliderKeyValue}` : undefined;
  // we _want_ to use the falsey value to avoid displaying the label when the index is the default, 0
  const indexLabel = index ? `Index: ${index}` : undefined;
  const stepLabel = `Step: ${step}`;
  return {
    sliderLabel,
    stepLabel,
    indexLabel,
  };
}

export function getTileMediaSpecs(
  mediaType: MediaCardType,
  paginatedTiles: GroupedList<Tile>
): TileMediaSpec[] {
  const tileMediaSpecs: TileMediaSpec[] = [];
  for (const tileOrGroup of paginatedTiles) {
    if (tileOrGroup == null) {
      continue;
    }

    const tiles =
      'groupType' in tileOrGroup ? tileOrGroup.items : [tileOrGroup];
    if (tiles.length === 0 || tiles[0].isEmpty) {
      continue;
    }

    for (const tile of tiles) {
      if (tile.isEmpty) {
        continue;
      }
      const {
        run,
        mediaIndex,
        mediaKey,
        mediaStep,
        runSignature,
        mediaSliderKey: sliderKey,
        mediaSliderKeyValue,
      } = tile;
      tileMediaSpecs.push({
        mediaType,
        mediaSliderKey: sliderKey ?? '_step',
        mediaSliderKeyValue,
        run,
        mediaIndex,
        mediaKey,
        mediaStep,
        runSignature,
      });
    }
  }
  return tileMediaSpecs;
}
